import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";
import {useMatchersSkusForm} from "../../@hooks";


export default function MatchersSKUsDrawerUnitySize() {
	const { localValue, handleChange } = useMatchersSkusForm('unitySize')

	return <SelectSeeker
		label="Unity Size"
		options={[
			{ value: 'ml', label: 'ml' },
			{ value: 'gr', label: 'gr' },
			{ value: 'pc', label: 'pc' },
		]}
		value={localValue || ''}
		onChange={e => handleChange(e.target.value)}
	/>
}
